import React from 'react';
import {ButtonIcon} from '@homeaway/react-buttons';
import {PRINT__24} from '@homeaway/svg-defs';

const PrintButton = ({label, onClick}) => {
    return <ButtonIcon label={label} svgMarkup={PRINT__24} onClick={onClick} />;
};

export default PrintButton;
